<template>
  <div>
    <v-text-field
      v-model="jyName"
      label="申請開通集運商名稱"
      solo
    />
    <v-textarea
      v-model="cause"
      label="必須使用該集運商的原因"
      auto-grow
      solo
    />
    <v-btn
      :disabled="!jyName || !cause"
      :loading="submitLoading"
      block
      color="info"
      @click="submit"
    >
      提交
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      submitLoading: false,
      jyName: '',
      cause: '',
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    async submit () {
      if (this.submitLoading) return
      try {
        this.submitLoading = true

        const params = {
          ignoreLimit: '1',
          tag: 'applyThirdPartyJy',
          // site: 'KK',
          title: '申請開通集運商',
          content: `${this.jyName} \n${this.cause}`,
          upyunFiles: [],
        }

        const res = await this.$store.dispatch('comment/createWorkOrder', params)
        if (!res.data.error) {
          this.jyName = ''
          this.cause = ''

          this.$snackbar('已提交申請', { color: 'success' })
          this.$emit('created', { cid: res.data.model.cid })
          localStorage.setItem('applyThirdPartyJy', '1')
        }
      } finally {
        this.submitLoading = false
      }
    },
  }
}
</script>
